import { Route, Routes } from "react-router-dom";
import About from "../../pages/about";
import Achievements from "../../pages/achievements";
import Contact from "../../pages/contact";
import Education from "../../pages/education";
import Experience from "../../pages/experience";
import Home from "../../pages/home";
import Projects from "../../pages/projects";
import SKills from "../../pages/skills";
import NotFound from "../not-found";

const NestedRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/skills" element={<SKills />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/achievements" element={<Achievements />} />
      <Route path="/experience" element={<Experience />} />
      <Route path="/education" element={<Education />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default NestedRoutes;
